export default {
    'en': {
        'yes': 'Yes',
        'no': 'No',
        'insert': 'Insert',
        'update': 'Update',
        'delete': 'Delete',
        'view': 'View',
        'user': 'User',
        'password': 'Password',
        'invalid': 'is invalid',
        'required-a': 'is required',
        'required-o': 'is required',
        'min-length': 'must have at least',
        'characters': 'characters',
        'language-select': 'Language',
        'onlaine-slogan': 'Technology combined with lean production',
        'tech':'Technology',
        'login-invalid': 'Invalid login data, try again or',
        'login-welcome-line-1': 'Welcome back',
        'login-welcome-line-2': 'Please sign in to your account.',
        'login-support-contact': 'Contact us',
        'login-dont-have-an-account': 'Don\'t have an account?',
        'login-keep': 'Keep me logged in',
        'login-button': 'Login to Enter',
        'login-recover-password': 'Recover Password',
        'login-logout': 'Please login again',
        'module-data': 'Data',
        'go-back':'Go back',
        'go-back-list': "Back to List",
        'next':'Next',
        'form': "Form",
        'list-of': "Listing of ",
        'all': "All",
        'duplicate':"Duplicate",
        'form-of': "Form of ",
        'no-record-found': "No records found!",
        'no-options': "No options found!",
        'not-have-access':'You do not have access',
        'not-have-access-include':'You do not have access to include ',
        'not-have-access-change':'You do not have access to change ',
        'not-have-Access-delete':'You do not have access to delete ',
        'not-have-access-view':'You do not have access to view ',
        'inserted-with-success':'inserted with success!',
        'altered-with-success':'altered with success!',
        'deleted-with-success':'deleted with success!',
        'confirm':'Confirm',
        'error':'Error',
        'msg-confirm-delete':'Are you sure you want to permanently delete it?',
        'msg-check-all-errors-before-continued':'Check for errors before proceeding',
    },
    'es': {
        'yes': 'Sí',
        'no': 'No',
        'insert': 'Insertar',
        'update': 'Actualizar',
        'delete': 'Eliminar',
        'view': 'Visualizar',
        'user': 'Usuario',
        'password': 'Contraseña',
        'invalid': 'no es válido',
        'required-a': 'se requiere',
        'required-o': 'se requiere',
        'min-length': 'mínimo',
        'characters': 'caracteres',
        'language-select': 'Idioma',
        'onlaine-slogan': 'Tecnología combinada con producción ajustada',
        'tech':'Tecnología',
        'login-invalid': 'Datos de inicio de sesión no válidos, inténtelo de nuevo o',
        'login-welcome-line-1': 'Bienvenido de nuevo, ',
        'login-welcome-line-2': 'Por favor, ingrese a su cuenta.',
        'login-support-contact': 'Entre en contacto',
        'login-dont-have-an-account': '¿No tienes una cuenta?',
        'login-keep': 'Mantenme conectado',
        'login-button': 'Inicio de sesión',
        'login-recover-password': 'Recuperar contraseña',
        'login-logout': 'Por favor inicie sesión de nuevo',
        'module-data': 'Catastro',
        'go-back':'Volver',
        'go-back-list': "Volver a la lista",
        'next':'Avançar',
        'form': "Forma",
        'list-of': "Listado de ",
        'all': "Todos",
        'duplicate':"Duplicar",
        'form-of': "Forma de ",
        'no-record-found': "¡No se encontraron registros!",
        'no-options': "¡No se encontraron opciones!",
        'not-have-access':'No tienes acceso',
        'not-have-access-include':'No tienes acceso para incluir ',
        'not-have-access-change':'No tienes acceso para cambiar ',
        'not-have-Access-delete':'No tienes acceso para eliminar ',
        'not-have-access-view':'No tienes acceso para ver ',
        'inserted-with-success':'añadid%gender%%plural% con exito!',
        'altered-with-success':'cambiad%gender%%plural% con exito!',
        'deleted-with-success':'eliminad%gender%%plural% con exito!',
        'confirm':'Confirmación',
        'error':'Erro',
        'msg-confirm-delete':'¿Está seguro de que desea eliminarlo de forma permanente?',
        'msg-check-all-errors-before-continued':'Compruebe si hay errores antes de continuar',
    },
    'pt-BR': {
        'yes': 'Sim',
        'no': 'Não',
        'insert': 'Inserir',
        'update': 'Atualizar',
        'delete': 'Excluir',
        'view': 'Visualizar',
        'user': 'Usuário',
        'password': 'Senha',
        'invalid': 'é inválido',
        'required-a': 'é requerida',
        'required-o': 'é requerido',
        'min-length': 'mínimo de',
        'characters': 'caracteres',
        'language-select': 'Idioma',
        'onlaine-slogan': 'Tecnologia aliada a produção enxuta',
        'tech':'Tecnologia',
        'login-invalid': 'Dados de login inválidos, tente novamente ou',
        'login-welcome-line-1': 'Acesso a Plataforma',
        'login-welcome-line-2': 'Realize o login da sua conta.',
        'login-support-contact': 'Entre em Contato',
        'login-dont-have-an-account': 'Não possui uma conta?',
        'login-keep': 'Lembrar-me',
        'login-button': 'Realizar Login',
        'login-recover-password': 'Recuperar Senha',
        'login-logout': 'Por favor, realize o login novamente',
        'module-data': 'Cadastro',
        'go-back':'Voltar',
        'go-back-list': "Voltar para Listagem",
        'next':'Avançar',
        'form': "Formulário",
        'list-of': "Listagem de ",
        'all': "Todos",
        'duplicate':"Duplicar",
        'form-of': "Formulário de ",
        'no-record-found': "Nenhum registro encontrado!",
        'no-options': "Nenhuma opção encontrada!",
        'not-have-access':'Você não possui acesso',
        'not-have-access-include':'Você não possu acesso a inclusão ',
        'not-have-access-change':'Você não possu acesso a alteração ',
        'not-have-Access-delete':'Você não possu acesso a exclusão ',
        'not-have-access-view':'Você não possu acesso a visualização ',
        'inserted-with-success':'incluíd%gender%%plural% com sucesso!',
        'altered-with-success':'alterad%gender%%plural% com sucesso!',
        'deleted-with-success':'excluíd%gender%%plural% com sucesso!',
        'confirm':'Confirmação',
        'error':'Erro',
        'msg-confirm-delete':'Tem certeza que deseja excluir definitivamente?',
        'msg-check-all-errors-before-continued':'Verifique os erros antes de continuar',

    }
}


